import { Box, Button, Grid, Typography } from '@mui/material';
import React from 'react';
import moment from 'moment';
import {
  BusinessCenterRounded,
  CallRounded,
  EmailRounded,
  HowToRegRounded,
  LocationOnRounded,
  MyLocationRounded,
  PhoneIphoneRounded,
  PublicRounded,
  WatchLaterRounded,
} from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import parse from "html-react-parser";


import { useResponsiveStyles } from '../../../utils/responsiveStyles';
import palette from '../../../theme/palette';
import { openUpgradeForm } from '../../../reducers/upgradePlanReducer';


const OverView = ({ customerDetailsData }) => {
  const styles = useResponsiveStyles();
  const dispatch = useDispatch();

  const handleOpenForm = (customerId, planData) => {
    dispatch(openUpgradeForm(customerId, planData));
  };


  function daysRemaining(date) {
    const expiryDate = moment(date).startOf('day');
    const todaysDate = moment().startOf('day');
    return expiryDate.diff(todaysDate, 'days');
  }


  const boxListStyles = {
    display: 'flex',
    gap: '20px',
    p: '10px',
  };

  const text1Styles = {
    m: 0,
    fontSize: styles.fontSize12,
    fontWeight: 500,
    color: palette.grey[800],
  };

  const iconStyles = {
    fontSize: styles.icon20,
    color: palette.grey[500],
  };
  const listItemGridStyles = {
    borderBottom: `1px solid ${palette.grey[200]}`
  }
  const listItemGridContainerStyles = {
    alignItems:'center'
  }
  const box1Styles = {display:'flex', gap:'16px', p:'10px'}
  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <Box sx={{ p: '6px' }}>
          <Grid container spacing={0}>
            <Grid item xs={12} sx={listItemGridStyles}>
            <Box sx={box1Styles}>
            <LocationOnRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
                {`${customerDetailsData?.userDetails?.cityname}, ${customerDetailsData?.userDetails?.statename} ${customerDetailsData?.userDetails?.zipcode}`}
              </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sx={listItemGridStyles}>
               
            <Box  sx={box1Styles}>
            <CallRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
                {customerDetailsData?.companyDetails?.contactphone ? customerDetailsData?.companyDetails?.contactphone : 'N/A'}
              </Typography>
            </Box>  
            </Grid>
            <Grid item xs={12} sx={listItemGridStyles}>
                
            <Box  sx={box1Styles}>
            <BusinessCenterRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
                {customerDetailsData?.userDetails?.role}
              </Typography>
            </Box>  
            </Grid>
            <Grid item xs={12} sx={listItemGridStyles}>
              
            <Box sx={box1Styles}>
              
            <EmailRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
                {customerDetailsData?.userDetails?.username}
              </Typography>
            </Box>   
            </Grid>
            <Grid item xs={12} sx={listItemGridStyles}>
              
            <Box sx={box1Styles}>
              
            <HowToRegRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
                {moment(customerDetailsData?.userDetails?.registerDate).format('LL')}
              </Typography>
                </Box>
            </Grid>
            <Grid item xs={12} sx={listItemGridStyles}>
            <Box sx={box1Styles}>
            <WatchLaterRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
                {daysRemaining(customerDetailsData?.packageDetails?.package_end_date)} days left
                {/* <Button variant='outlined' size='small' sx={{ml: '6px'}} onClick={() => handleOpenForm(customerDetailsData?.userDetails?.id, customerDetailsData)}>Upgrade Plan</Button> */}
              </Typography>
            </Box>   
            </Grid>
          </Grid>
          {/* <Box>
            <Box sx={boxListStyles}>
              <LocationOnRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
                {`${customerDetailsData?.userDetails?.zipcode}, ${customerDetailsData?.userDetails?.cityname}, ${customerDetailsData?.userDetails?.statename}.`}
              </Typography>
            </Box>
            <Box sx={boxListStyles}>
              <CallRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
                {customerDetailsData?.userDetails?.phone_number}
              </Typography>
            </Box>
            <Box sx={boxListStyles}>
              <EmailRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
                {customerDetailsData?.userDetails?.username}
              </Typography>
            </Box>
            <Box sx={boxListStyles}>
              <BusinessCenterRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles }}>
                {customerDetailsData?.userDetails?.role}
              </Typography>
            </Box>
            <Box sx={boxListStyles}>
              <PublicRounded sx={iconStyles} />
              <Typography paragraph sx={{ ...text1Styles, textDecoration: 'underline' }}>
                {`${customerDetailsData?.companyDetails?.domain_name}`}
              </Typography>
            </Box>
          </Box> */}
        </Box>
      </Grid>
    </Grid>
  );
};

export default OverView;
